// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__q_dlc","toggle":"styles_toggle__uOlH3","preview":"styles_preview__3zkot"};